<script>
    export let center;
    export let zoom = 12;
    export let width;
    export let height;
    export let onChange = () => {};
    export let addDraw;
    export let interactions = true;
    export let features;
    export let backgroundFeatures;
    export let rendercomplete = null;
    export let outputDimension;
    export let displayOutputDimension;
    export let basemap = {};

    import { onMount } from 'svelte';

    import 'ol/ol.css';
    import Map from 'ol/Map';
    import {Tile, Vector as VectorLayer} from 'ol/layer';
    import XYZ from 'ol/source/XYZ';
    import TileLayer from 'ol/layer/Tile';
    import {OSM, Vector as VectorSource} from 'ol/source';
    import Feature from 'ol/Feature';
    import View from 'ol/View';
    import {fromExtent} from 'ol/geom/Polygon';
    import {getCenter, getWidth, getHeight} from 'ol/extent';

    import { fromLonLat, toLonLat, transformExtent } from 'ol/proj';
    import GeoJSON from 'ol/format/GeoJSON';
    import Polygon from 'ol/geom/Polygon';
    import Circle from 'ol/geom/Circle';

    import Draw, {createBox, createRegularPolygon} from 'ol/interaction/Draw';
    import {defaults as defaultInteractions} from 'ol/interaction.js';
    import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
    import {getVectorContext} from 'ol/render';

    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;


    const foreGroundStyle = (feature) =>{
        return new Style({
            fill: new Fill({
                color: 'rgba(255,255,255,0.2)',
            }),
            stroke: new Stroke({
                color: typeof(feature.get('label')) !== 'undefined' ? 'rgba(146,21,255,0.9)' : 'rgba(255,0,0,0.9)'
            })
        })
    }
    const backgroundExtentStyle = new Style({
        stroke: new Stroke({
            //lineDash: [4,8],
            width: 2,
            color: 'rgba(146,21,255,0.6)',
        })
    })
    const clipStyle = new Style({
        stroke: new Stroke({
            lineDash: [4,8],
            width: 3,
            color: 'rgba(146,21,255,0.6)',
        })
    })
    const backgroundStyle = new Style({
        fill: new Fill({
            color: 'rgba(0,0,0,0.5)',
        })
    })
    const style = new Style({
        fill: new Fill({
            color: 'white',
        }),
    });

    let map;
    let draw;
    let view
    let mapElement
    let geoJsonLayer
    

    const drawSource = new VectorSource({wrapX: false});
    const detectedSource = new VectorSource();
    const foreGroundSource = new VectorSource();
    const backGroundExtentsSource = new VectorSource();

    const backGroundSource = new VectorSource();
    const backGroundClipSource = new VectorSource();
    const mapTileLayer = new TileLayer({
        source: new XYZ({
            url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            crossOrigin: 'anonymous',
        }),
    });

    let foreGroundLayer = new VectorLayer({
         source: foreGroundSource,
         style: foreGroundStyle
    });
    let backGroundExtentsLayer = new VectorLayer({
         source: backGroundExtentsSource,
         style: backgroundExtentStyle
    });
    let backGroundLayer = new VectorLayer({
         source: backGroundSource,
         style: backgroundStyle
    });
    let backGroundClipLayer = new VectorLayer({
         source: backGroundClipSource,
         style: clipStyle
    });

    

    backGroundLayer.on('postrender', function (e) {
        if(isFirefox) return;

        const vectorContext = getVectorContext(e);
        e.context.globalCompositeOperation = 'destination-out';
        backGroundClipLayer.getSource().forEachFeature(function (feature) {
            vectorContext.drawFeature(feature, style);
        });
        backGroundExtentsLayer.getSource().forEachFeature(function (feature) {
            vectorContext.drawFeature(feature, style);
        });
        e.context.globalCompositeOperation = 'source-over';
    });

    const setCenter = (center, zoom) => {
        
        if(!view || !center || ! zoom) return

        view.setCenter([center[0], center[1]]);
        //view.setCenter(fromLonLat([center[0], center[1]]))
        view.setZoom(zoom)
    }
    export function updateGeoJson(geoJson) {
        if(!view) return

        if(geoJson){
            geoJsonLayer.clear();
            const features = new GeoJSON({featureProjection: 'EPSG:3857'}).readFeatures(geoJson)
            geoJsonLayer.addFeatures(features);

            view.fit(geoJsonLayer.getExtent(), {
                maxZoom: 21
            });
        }
    }
    const createRectangleFromExtent = (extent, label) => {
        let poly = fromExtent(extent);
        let polyFeature = new Feature(poly)
        polyFeature.setProperties({label})
        return polyFeature;
    }
    const createCircleFromExtent = (extent, label) => {
       
        const center = getCenter(extent);
        const radius = getWidth(extent)/2;
        
        const circle = new Circle(center, radius)
        const polyFeature = new Feature(circle)
        polyFeature.setProperties({label})

        return polyFeature;
    }
    const changeFeatures = (foreground) => {
        if(!foreground) return;
        foreGroundSource.clear();
        const features = [];
        foreground.extents.forEach(element => {
            let feature;
            if(element.type === 'Circle'){
                feature = createCircleFromExtent(element.extent, element.label);
            }else{
                feature = createRectangleFromExtent(element.extent, element.label);
            }
            feature.setId(element.id);
            
            if(feature) features.push(feature)
        })
        foreGroundSource.addFeatures(features)
    }
    const changeBackgroundExentFeatures = (extents) => {
        if(!extents) return;

        let _extents = Object.assign({}, extents);

        backGroundExtentsSource.clear();
        const features = [];
        _extents.extents.forEach(element => {
            if(!element.extent) return;

            let feature;
            feature = createRectangleFromExtent(element.extent, element.label);
            feature.setId(element.id);
            
            if(feature) features.push(feature)
        })
        backGroundExtentsSource.addFeatures(features)
    }
    
    onMount(() => {
        
        view = new View({
            minZoom: 4,
            maxZoom: 21,
            enableRotation: false
        });
        geoJsonLayer = new VectorSource();

        map = new Map({
            controls: [],
            target: mapElement,
            interactions: interactions ? defaultInteractions() : [],
            view: view,
            layers: [
                mapTileLayer,
                //backGroundLayer,
                backGroundClipLayer,
                new VectorLayer({
                    source: geoJsonLayer
                }),
                new VectorLayer({
                    source: detectedSource
                }),
                new VectorLayer({
                    source: drawSource,
                }),
                backGroundExtentsLayer,
                foreGroundLayer
            ]
        });
        if(!isFirefox){
            var layers = map.getLayers();
            layers.insertAt(1,backGroundLayer);
        }

        map.on('moveend', e => onChange(map.getView()));
        //update(geoJson)
        
        map.on('rendercomplete', function(event) {
            if(!rendercomplete) return;

            rendercomplete(getBboxExt());
            //rendercomplete(true);
            //view.setCenter()
        });
        createBackgroundLayer();
        setCenter(center, zoom)
        redraw();
    })
    const createBackgroundLayer = () => {
        backGroundSource.clear();
        let poly = fromExtent([-20037508.3427892, -20037508.3427892, 20037508.3427892, 20037508.3427892]);
        backGroundSource.addFeature(new Feature(poly));
    }
    export function getBboxExt(){
        return map.getView().calculateExtent(map.getSize());
    }
    export function addDetectedExt(detected){
        detectedSource.clear();
        detected.forEach(element => {
            let poly = fromExtent(element.bbox);
            detectedSource.addFeature(new Feature(poly));
        });
        
    }
    export function redraw(){
        setTimeout(() => {
            map.updateSize();
            map.render();
        }, 100);
    }
    export function coordinatesToLatLong(coordinates){
        return toLonLat(coordinates);
    }
    export function toLatLong(bbox){
        return transformExtent(bbox, 'EPSG:3857', 'EPSG:4326');
    }
    function getCenterOfExtent(Extent){
        var X = Extent[0] + (Extent[2]-Extent[0])/2;
        var Y = Extent[1] + (Extent[3]-Extent[1])/2;
        return [X, Y];
    }
    export function focusLatLngExtent(extent){
        const intExtent = transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
        view.fit(intExtent, {
            maxZoom: 21
        });
        //view.fit(intExtent, map.getSize()); 
    }
    export function focusExtent(extent, zoom){
        view.setCenter(getCenterOfExtent(extent))
        view.setZoom(zoom)
    }
    export function focus(center, zoom){
        view.setCenter(center)
        view.setZoom(zoom)
    }
    export function getPixelFromCoordinate(coordinate){
        return map.getPixelFromCoordinate(coordinate);
    }
    export function addInteraction(value = 'Circle'){

        if(draw) map.removeInteraction(draw);

        if(value===null){
            return;
        }

        let geometryFunction;

        if(value==='Circle'){

        }else if(value==='Square'){
            geometryFunction = createRegularPolygon(4);
        }else if(value==='Box'){
            geometryFunction = createBox();
        }

        draw = new Draw({
            source: drawSource,
            type: 'Circle',
            geometryFunction: geometryFunction,
        });
        draw.on('drawend', function (event) {
            const feature = event.feature;
            const extent = feature.getGeometry().getExtent();

            const topLeft = map.getPixelFromCoordinate([extent[0], extent[3]]);
            const bottomRight = map.getPixelFromCoordinate([extent[2], extent[1]]);

            addDraw([...topLeft, ...bottomRight], extent, zoom, [Math.round(getWidth(extent)*100)/100, Math.round(getHeight(extent)*100)/100]);

            setTimeout(() => {
                drawSource.clear();
            }, 100)
            
            //var selectSource = map.getLayer(feature).getSource();
            //selectSource.clear();
            //map.removeInteraction(draw);
            //map.addInteraction(draw);
        })
        map.addInteraction(draw);
    }
    export function getExtentFromDimensions(outputDimension){
        if(!map || !view || !outputDimension) return;
        const center = view.getCenter();
        if(!center) return;
        
        var pixel = map.getPixelFromCoordinate(center);
        if(!pixel) return;

        const minX = pixel[0] - outputDimension[0]/2
        const maxX = pixel[0] + outputDimension[0]/2
        const minY = pixel[1] - outputDimension[1]/2
        const maxY = pixel[1] + outputDimension[1]/2

        const topLeft = map.getCoordinateFromPixel([minX, minY]);
        const bottomRight = map.getCoordinateFromPixel([maxX, maxY]);

        return [...topLeft, ...bottomRight];
    }
    const updateBackground = (outputDimension) => {
        
        if(!map || !view || !outputDimension) return;
        const center = view.getCenter();
        if(!center) return;
        
        var pixel = map.getPixelFromCoordinate(center);
        if(!pixel) return;

        const minX = pixel[0] - outputDimension[0]/2
        const maxX = pixel[0] + outputDimension[0]/2
        const minY = pixel[1] - outputDimension[1]/2
        const maxY = pixel[1] + outputDimension[1]/2

        const topLeft = map.getCoordinateFromPixel([minX, minY]);
        const bottomRight = map.getCoordinateFromPixel([maxX, maxY]);
        
        backGroundClipSource.clear();
       
        let poly = fromExtent([...topLeft, ...bottomRight]);
        backGroundClipSource.addFeature(new Feature(poly));
    }

    const changeDisplayOutputDimension = (displayLayer) => {
        backGroundLayer.setVisible(displayLayer);
        backGroundClipLayer.setVisible(displayLayer);
    }

    const changeBaseMap = (basemap) => {
        if(!basemap.host) return;
        const xyz = new XYZ({
            url: basemap.host[0],
            crossOrigin: 'anonymous',
        });

        mapTileLayer.setSource(xyz);
        mapTileLayer.setMaxZoom(basemap.maxZoom);
    }
    $: changeBaseMap(basemap);
    $: changeBackgroundExentFeatures(backgroundFeatures);
    $: [
        //update(geoJson),
        updateBackground(outputDimension),
        changeFeatures(features),
        setCenter(center, zoom),
        changeDisplayOutputDimension(displayOutputDimension),
        
    ]

</script>

<div class="map" bind:this={mapElement} style={'width:' + width + '; height:' + height + ';'}></div>
<slot></slot>

